/** Same default as `redux/baseApi.js` — keep in sync. */
export const API_BASE_URL = String(
  process.env.REACT_APP_API_BASE_URL || 'https://growerstaging-internaladmin.pixoatic.in/'
).replace(/\/+$/, '');

export function normalizeUrlSlashes(url) {
  if (!url || typeof url !== 'string') return '';
  return url.replace(/([^:])\/{2,}/g, '$1/');
}

/**
 * Turn API image/blob paths into absolute URLs the browser can request.
 * Handles strings and common Rails / serializer object shapes.
 */
export function resolveAssetUrl(value) {
  const raw =
    typeof value === 'string'
      ? value
      : value && typeof value === 'object'
        ? value.url ||
          value.path ||
          value.image_url ||
          value.imageUrl ||
          value.file_url ||
          value.full_url ||
          value.preview_url ||
          value.picture_url ||
          value.large ||
          value.medium ||
          value.thumbnail ||
          value.large_url ||
          value.thumb_url ||
          value.medium_url
        : '';
  let s = String(raw || '').trim();
  if (!s) return '';
  s = normalizeUrlSlashes(s);
  if (/^https?:\/\//i.test(s)) return s;
  if (s.startsWith('//')) return `https:${s}`;
  if (s.startsWith('/')) return `${API_BASE_URL}${s}`;
  // Some APIs omit the leading slash (e.g. "rails/active_storage/...")
  if (/^(rails\/|storage\/)/i.test(s)) return `${API_BASE_URL}/${s.replace(/^\/+/, '')}`;
  return s;
}
